import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/contracts`, parameters)
    },

    update (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/contracts`, parameters)
    },

    create (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/contracts/create`, parameters)
    },

    delete (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/contracts/delete`, parameters)
    },

    restore (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/contracts/restore`, parameters)
    },
}
